import { useState } from "react"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import * as userSlice from "../store/user"
import * as authApis from "../utilities/apis/auth"
import GuestLayout from "../components/GuestLayout"

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      const form = new FormData(e.target)
      const username = form.get("username")
      const password = form.get("password")

      if (!username) throw new Error("Username is required")
      if (!password) throw new Error("Password is required")

      const response = await authApis.login({ username, password })
      if (!response.status) throw new Error(response.message)

      dispatch(userSlice.login(response))
      navigate("/dashboard")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <main className="py-3">
        <div className="container">
          <div className="row">
            <div className="col-md-2 col-lg-3 col-xl-4"></div>
            <div className="col-md-8 col-lg-6 col-xl-4">
              <div className="card rounded-4 shadow-none">
                <div className="card-body py-4">
                  <div className="text-center mb-3">
                    <img src="/logo192.png" width={96} />
                  </div>
                  <div className="text-center mb-5">
                    <h3 className="text-body-emphasis fw-bold m-0">Phonics</h3>
                    <p className="lead fw-semibold text-body-secondary m-0">Login to Continue</p>
                  </div>

                  <form method="POST" onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="username" className="form-label">Username</label>
                      <input type="text" name="username" className="form-control rounded-3" id="username" required disabled={loading} />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Password</label>
                      <input type="password" name="password" className="form-control rounded-3" id="password" required disabled={loading} />
                    </div>
                    <div className="text-end mb-3">
                      <Link to="/validate-email">Forgot Password?</Link>
                    </div>
                    <div className="mb-5">
                      <button type="submit" className="btn btn-theme rounded-3 w-100" disabled={loading}>Login</button>
                    </div>
                    <div className="text-center">
                      <p className="m-0">Don't have an account? <Link to="/register" className="fw-semibold">Register now</Link></p>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-md-2 col-lg-3 col-xl-4"></div>
          </div>
        </div>
      </main>
    </GuestLayout>
  )
}

export default Login